import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const upsertPlayer = (username, email) =>
  axios.post(`${API}/players`, { username, email: email || null }).then((r) => r.data);

export const postMatch = (payload) =>
  axios.post(`${API}/matches`, payload).then((r) => r.data);

export const getStats = (username) =>
  axios.get(`${API}/players/${encodeURIComponent(username)}/stats`).then((r) => r.data);

export const getMatches = (username, limit = 20) =>
  axios
    .get(`${API}/players/${encodeURIComponent(username)}/matches`, { params: { limit } })
    .then((r) => r.data);

export const getLeaderboard = (period = "week") =>
  axios.get(`${API}/leaderboard`, { params: { period } }).then((r) => r.data);
